<template>
  <div class="main admin-tests-edit">
    <FormWrapper :action="formAction" :method="formMethod">
      <div class="title-bar">
        <h1 class="mb-0">{{ test.id ? "Edit" : "Add New" }} Test</h1>
        <a class="btn-back" :href="route('admin.tests.index')">
          <span class="icon icon-arrow-left"></span>
          <span class="text">Back to List</span>
        </a>
      </div>

      <div class="row no-gutters py-4">
        <div class="col-12 col-lg-8 col-xl-9">
          <div class="row no-gutters px-3 pl-lg-4 pr-lg-0 pl-xl-5">
            <div class="col-12">
              <transition name="fade">
                <Alert v-if="hasAlert" :alert="alert" />
              </transition>
            </div>

            <div class="col-12 mb-3">
              <Field type="text" name="name" label="Name" :value="test.name" validate="required" />
            </div>

            <div class="col-12">
              <hr />
              <h4 class="text-primary text-uppercase mb-4">Questions</h4>
              <FieldEditor
                :value="selectedField"
                :currentFields="assignedFields"
                :fieldTypes="fieldTypes"
                @submit="addField"
              />
            </div>

            <div v-if="assignedFields.length > 0" class="col-12">
              <hr />
              <FieldList
                :assigned="assignedFields"
                :field-types="fieldTypes"
                @edit="editField"
                @remove="removeField"
              />
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-4 col-xl-3 form-button-wrapper">
          <div class="sticky-top">
            <div class="row no-gutters text-center">
              <div class="col-12">
                <h4 class="text-uppercase text-center">Status</h4>
                <SwitchField
                  name="is_active"
                  on-label="Active"
                  off-label="Inactive"
                  :value="!!test.is_active ? 1 : 0"
                />
                <hr class="w-75" />
              </div>
              <div class="col-12 pb-3">
                <button type="submit" class="btn btn-success w-50">Save Changes</button>
              </div>
              <div class="col-12 pb-3">
                <a :href="route('admin.tests.index')" class="btn btn-danger w-50">Cancel & Exit</a>
              </div>
              <template v-if="test.id">
                <div class="col-12 pb-3">
                  <a
                    :href="route('admin.tests.submissions.index', routeParam)"
                    class="btn btn-info w-50"
                  >View Submissions</a>
                </div>
                <div class="col-12 font-size-sm text-center pt-4">
                  <span>Last updated on {{ test.updated_at | moment("MM/DD/YYYY") }}</span>
                  <span>at {{ test.updated_at | moment("h:mma") }}</span>
                  <span v-if="test.updated_by">{{ " " + test.updated_by.name }}</span>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
    </FormWrapper>
  </div>
</template>

<script>
import DisplaysAlerts from "mixins/DisplaysAlerts";
import HasFields from "mixins/Forms/HasFields";
import FieldEditor from "./partials/FieldEditor";
import FieldList from "./partials/FieldList";

export default {
  mixins: [DisplaysAlerts, HasFields],
  components: { FieldEditor, FieldList },
  props: {
    test: { type: Object, required: true },
    fieldTypes: { type: Array, required: true },
    testTypes: { type: Array, required: true },
  },
  data() {
    return {
      //
    };
  },
  computed: {
    routeParam() {
      return { test: this.test.id || null };
    },
    formAction() {
      return !this.test.id
        ? this.route("admin.tests.store")
        : this.route("admin.tests.update", this.routeParam);
    },
    formMethod() {
      return !this.test.id ? "POST" : "PUT";
    },
  },
  watch: {
    //
  },
  mounted() {
    if (_.has(this.test, "fields") && _.isArray(this.test.fields)) {
      this.assignedFields = _.cloneDeep(this.test.fields);
    }
  },
};
</script>